import { URL_SUPPORT_TERMS } from '@seek/adv-constants';
import { useTranslations } from '@vocab/react';
import {
  CheckboxStandalone,
  IconCritical,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import { Controller } from 'react-hook-form';

import { TextLink } from 'src/components/Link/Link';

import lysTranslations from 'src/pages/LinkYourSoftware/.vocab';

export const TermsAndConditions = () => {
  const { t: lys } = useTranslations(lysTranslations);
  return (
    <Controller
      name="reviewTerms"
      rules={{
        required: lys('termsAndConditionsValidation'),
      }}
      render={({ field, fieldState }) => (
        <Stack space="small">
          <Inline space="small" alignY="center">
            <CheckboxStandalone
              id="lys-review-terms"
              checked={field.value}
              onChange={field.onChange}
              aria-label="Agree to Terms and Conditions"
              tone={
                Boolean(fieldState.invalid || fieldState.error)
                  ? 'critical'
                  : 'neutral'
              }
            />
            <Text>
              {lys('agreeTermsAndConditions', {
                TextLink: (children) => (
                  <TextLink
                    href={URL_SUPPORT_TERMS}
                    target="_blank"
                    tracking="terms-agreement-clicked"
                  >
                    {children}
                  </TextLink>
                ),
              })}
            </Text>
          </Inline>
          {fieldState.error && (
            <Text
              id="lys-review-terms-error-message"
              icon={<IconCritical />}
              tone="critical"
              size="small"
            >
              {fieldState.error.message}
            </Text>
          )}
        </Stack>
      )}
    />
  );
};
